import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { StorageService, StorageType } from 'app/services/storage/storage.service';
import { CookieService } from 'ng2-cookies';
import { Subscription } from 'rxjs';
import { ApplicationStore } from 'app/state-management/application/application.store';
import * as fromProfile from '../../reducers/profile';
import * as cookieExpiration from '../../utils/expires';

@Component({
    selector: 'ecn-page-redirect',
    templateUrl: './page-redirect.component.html',
    styleUrls: ['./page-redirect.component.scss'],
    standalone: false
})
export class PageRedirectComponent implements OnInit, OnDestroy {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  cookieService = inject(CookieService);
  store = inject(Store);
  private storageService = inject(StorageService);
  private appStore: ApplicationStore = inject(ApplicationStore);

  subscriptions = new Subscription();


  ngOnInit(): void {
    this.subscriptions.add(
      this.store.select(fromProfile.selectProfile).subscribe(identity => {
        // this is called first with null
        if (!identity) {
          return;
        }

        // second call after identity was send from backend
        const tenantId: string = this.route.snapshot.queryParamMap.get('tid');
        let path: string = decodeURIComponent(this.route.snapshot.queryParamMap.get('path'));

        if (!tenantId || !path) {
          this.router.navigate(['/page-not-found']);
          return;
        }

        // Case for redirect from MAIL template
        if (path.includes('incidents/details')) {
          path = path.replace('incidents/details', 'incidents/for-machine/details');
        }

        if (identity.tenantId === tenantId) {
          // user is already in the right tenant
          this.router.navigate(['/'].concat(path.split('/')));
        } else {
          // wrong tenant: switch to the one from the parameters and reload whole application
          this.storageService.deleteAll(StorageType.Session);
          this.appStore.clearCachedApiData();
          this.cookieService.set('ecn-smartenance-current-tenant', tenantId, cookieExpiration.expires(), '/');
          window.location.href = window.location.origin + '/' + path;
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
